export const SET_WEBSITE_MODE = 'SET_WEBSITE_MODE'
export const SET_CURRENT_FILE_KEY = 'SET_CURRENT_FILE_KEY'
export const SET_DATA_STATUS = 'SET_DATA_STATUS'
export const SET_CURRENT_TAB_INDEX = 'SET_CURRENT_TAB_INDEX'
export const SET_CURRENT_TAB_DATA = 'SET_CURRENT_TAB_DATA'
export const ADD_NEW_TAB_DATA = 'ADD_NEW_TAB_DATA'
export const DELETE_TAB_DATA = 'DELETE_TAB_DATA'
export const SET_TOOL_SETTINGS_ACTIVE_INDEX = 'SET_TOOL_SETTINGS_ACTIVE_INDEX'
export const SET_IS_TOOL_SPINNING = 'SET_IS_TOOL_SPINNING'
